<div
  class="flex flex-row items-center w-full border border-primary border-solid rounded-md shadow overflow-clip bg-surface"
  [ngClass]="[sizeClass(), customClass()]"
>
  <button
    class="soft-button primary !text-4xl w-1/4 !h-full content-center min-w-[40px] justify-center items-center flex"
    [ngClass]="[size() !== 'default' ? '!text-xl' : '!text-4xl', decrementButtonClass()]"
    [disabled]="disabled || decrementDisabledFn()()"
    (click)="decrement(input)"
    id="soft-minus-test"
  >
    -
  </button>
  <div
    class="flex flex-col w-1/2 justify-center h-full items-center"
    [ngClass]="inputClass ? inputClass : ''"
    [ngStyle]="inputStyle"
  >
    <div class="flex items-center">
      <input
        type="text"
        inputmode="numeric"
        #input
        (focus)="
          $event.stopPropagation();
          $event.stopImmediatePropagation();
          $event.preventDefault();
          onFocus(input)
        "
        [ngClass]="[
          inputFieldClass ? inputFieldClass : '',
          size() !== 'default' ? 'text-lg' : 'text-xl',
        ]"
        class="!select-none pb-0 mb-0 !border-none w-full text-center !appearance-none font-semibold [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        (input)="onInput($event, input?.value ?? null)"
        (keydown.enter)="onEnterWhenFocused($event, input)"
        (blur)="onBlur(input)"
        (contextmenu)="$event.preventDefault()"
        [value]="
          _displayedValue() === ''
            ? '0'
            : float
              ? (_displayedValue() | mengenEingabeFormat: 10)
              : (_displayedValue() | mengenEingabeFormat: 0)
        "
      />
      @if (minValue && showMinValue) {
        <p class="pb-0 mb-[1px] text-center font-semibold">
          {{ ' / ' }}
        </p>
        <p class="pb-0 mb-[1px] w-full text-center font-semibold">
          {{ minValue | mengenEingabeFormat: 0 }}
        </p>
      }
    </div>
    @if (einheit) {
      <div
        class="font-semibold color-light"
        [ngClass]="[size() !== 'default' ? 'text-xs -mt-1' : '']"
      >
        {{ einheit }}
      </div>
    }
  </div>

  <button
    class="soft-button primary !text-4xl w-1/4 !h-full content-center min-w-[40px] justify-center items-center flex"
    [ngClass]="[size() !== 'default' ? '!text-xl' : '!text-4xl', incrementButtonClass()]"
    [disabled]="disabled || incrementDisabledFn()()"
    (click)="increment()"
    id="soft-plus-test"
  >
    +
  </button>
</div>
